import React from 'react';
import { Button } from './ui/button';
import { CheckCircle, Clock, TrendingUp } from 'lucide-react';

export const Hero = () => {
  const appUrl = 'https://app.tuasistencia.com.co';

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 bg-gradient-to-b from-blue-50 to-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-8">
            <CheckCircle size={16} />
            Hecho para instituciones educativas
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Control de asistencia escolar{' '}
            <span className="text-blue-600">sin complicaciones</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Registra aulas, invita estudiantes por link y toma asistencia en segundos (sin app).
            Genera reportes automáticos y exporta a Excel/PDF. Ideal para colegios en Colombia.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              size="lg"
              onClick={() => window.location.href = appUrl}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-6 text-lg w-full sm:w-auto shadow-lg hover:shadow-xl transition-all duration-200"
            >
              Empezar gratis
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => window.location.href = appUrl}
              className="font-semibold px-8 py-6 text-lg w-full sm:w-auto border-2 hover:bg-gray-50 transition-all duration-200"
            >
              Iniciar sesión
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Clock size={18} className="text-blue-600" />
              <span>Sin instalación</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full"></div>
            <div className="flex items-center gap-2">
              <CheckCircle size={18} className="text-blue-600" />
              <span>Gratis para empezar</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full"></div>
            <div className="flex items-center gap-2">
              <TrendingUp size={18} className="text-blue-600" />
              <span>Reportes automáticos</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
    </section>
  );
};
